<!-- <div class="row">
  <div class="col-10 col-sm-10">
    <h1 mat-dialog-title>Subscription Plans</h1>
  </div>
  <div class="col-2 col-sm-2 text-right">
    <button mat-icon-button [mat-dialog-close]="true">
      <mat-icon>close</mat-icon>
    </button>
  </div>
</div> -->
<!-- <div>
  <br>
  <div class="row c-row">
    <div class="col-sm-4">
      <mat-card class="example-card" style="background-color: #c3c3c3;">
        <mat-card-header>
          <div class="row text-center">
            <mat-card-title>Bronze</mat-card-title>
 -->

<!-- <mat-card-subtitle>$59 per month</mat-card-subtitle> -->

<!-- 
          </div>
        </mat-card-header>
        <mat-card-content>
          <p class="text-center">For Single Store Operator</p>
          <p class="text-center">0.05 cents per code</p>
          <p class="text-center">(Includes generating code, claim, secured validate & redeem)</p>
          <p class="text-center">Yearly get 1 month free</p>
          <p class="text-center">Single store</p>

          <ul>
            <li>Dashboard</li>
            <li>Coupon Builder Studio</li>
            <li>Single Use Digital coupons</li>
            <li>Secured Validation widget</li>
            <li>Unique Campaign QR Code</li>
            <li>Share banner link</li>
            <li>Unlimited Campaigns</li>
            <li>Onboarding & Training</li>
            <li>Support</li>
          </ul>
        </mat-card-content>
        <mat-card-actions>
          <button class="col-sm-12" mat-flat-button (click)="onClickSubscription('Bronze')">Buy Now</button>
        </mat-card-actions>
      </mat-card>
    </div>
    <div class="col-sm-4">
      <mat-card class="example-card" style="background-color: #FFEBEB;">
        <mat-card-header>
          <div class="row text-center">
            <mat-card-title>Silver</mat-card-title> -->


<!-- <mat-card-subtitle>$199 per month</mat-card-subtitle> -->


<!-- </div>
        </mat-card-header>
        <mat-card-content>
          <p class="text-center">For Single & Multi-store chain</p>
          <p class="text-center">0.05 cents per code</p>
          <p class="text-center">(Includes generating code, claim, secured validate & redeem)</p>
          <p class="text-center">Yearly get 1 month free</p>
          <p class="text-center">50 stores</p>

          <p><b>Everything in Bronze</b></p>

          <ul>
            <li>Buy X and Get Y</li>
            <li>Happy Hours Sales</li>
            <li>Weekday Specials</li>
            <li>Digital Coupon Banner</li>
            <li>Real time performance tracker</li>
            <li>Customer sign in option</li>
            <li>Demographic report</li>
            <li>QR code & traffic analyzer</li>
            <li>Coupon click stats</li>
            <li>Coupon claim stats</li>
            <li>Campaign performance</li>
            <li>ROI calculator</li>
            <li>Reconciliation report</li>
          </ul>
        </mat-card-content>
        <mat-card-actions>
          <button class="col-sm-12" mat-flat-button (click)="onClickSubscription('Silver')">Buy Now</button>
        </mat-card-actions>
      </mat-card>
    </div>
    <div class="col-sm-4">
      <mat-card class="example-card" style="background-color: #FFD93D;">
        <mat-card-header>
          <div class="row text-center">
            <mat-card-title>Gold</mat-card-title> -->


<!-- <mat-card-subtitle>$399 per month</mat-card-subtitle> -->

<!--             
          </div>
        </mat-card-header>
        <mat-card-content>
          <p class="text-center">For Multi-store chain, Vendors & Manufactures</p>
          <p class="text-center">0.05 cents per code</p>
          <p class="text-center">(Includes generating code, claim, secured validate & redeem)</p>
          <p class="text-center">Yearly get 1 month free</p>
          <p class="text-center">200 stores</p>

          <p><b>Everything in Silver</b></p>

          <ul>
            <li>Sampling</li>
            <li>Gift vouchers</li>
            <li>Frequent Buy offers</li>
            <li>Customer acquisitions</li>
            <li>ScanCoupon Directory</li>
            <li>Ad in ScanCoupon.live</li>
            <li>Invite Participating Stores</li>
            <li>Store settlement report</li>
            <li>Store performance tracker</li>
            <li>Accounts manager</li>
          </ul>
        </mat-card-content>
        <mat-card-actions>
          <button class="col-sm-12" mat-flat-button (click)="onClickSubscription('Gold')">Buy Now</button>
        </mat-card-actions>
      </mat-card>
    </div> -->


<!-- <div class="col-sm-3">
      <mat-card class="example-card" style="background-color: #8EC3B0;">
        <mat-card-header>
          <div class="row text-center">
            <mat-card-title>Custom</mat-card-title>
            <mat-card-subtitle>$. per month</mat-card-subtitle>
          </div>
        </mat-card-header>
        <mat-card-content>
          <p class="text-center">For large Enterprises</p>
          <p class="text-center">Not finding what you are looking for? Tell to us for a customised solution</p>
          <p>Unlimited store location</p>

          <p><b>Everything in Gold</b></p>

          <ul>
            <li>Third party integration</li>
            <li>Custom applications</li>
          </ul>
        </mat-card-content>
        <mat-card-actions>
          <button class="col-sm-12" mat-flat-button>Buy Now</button>
        </mat-card-actions>
      </mat-card>
    </div> -->

<!--     
  </div>
  <br>
</div> -->
<!-- 
<div class="pricing-section">
    <div class="pricing-header">
      <h2>Contact Share & Lead Capture</h2>
      <p>Capture every interaction and turn it into an opportunity. One QR code — unlimited potential.</p>
    </div>

    <div class="pricing-cards-container">
      
      <div class="card solo-card">
        <span class="badge">SOLO</span>
        <div class="price-block">
          <span id="solo-original-price" class="original-price"></span>
          <h3 class="price"><span id="solo-current-price"></span> <span class="period" id="solo-period"></span></h3>
        </div>
        
        <ul class="features">
          <li><span class="icon purple-check">✔</span> 1 QR V Card</li>
          <li><span class="icon purple-check">✔</span> Unlimited QR scans & interactions</li>
          <li><span class="icon purple-check">✔</span> Contact sharing & context capture</li>
          <li><span class="icon purple-check">✔</span> Lead classification<br><span class="sub-feature">(Hot / Warm / Cold)</span></li>
          <li><span class="icon purple-check">✔</span> Personal contact book</li>
          <li><span class="icon purple-check">✔</span> Export to CRM & Analytics</li>
        </ul>
        <button class="btn gradient-btn">Try Now</button>
      </div>

      <div class="card team-card active">
        <span class="badge">TEAM</span>
        <div class="price-block">
          <h3 class="price"><span id="team-current-price"></span> <span class="period" id="team-period"></span></h3>
          <p class="subtext">Default: 5 Users (5 - 10 - 25 - 50 - 100)</p>
        </div>
        
        <ul class="features">
          <li><span class="icon green-check">✔</span> Everything in Solo</li>
          <li><span class="icon green-check">✔</span> Up to 5 user QR V Cards</li>
          <li><span class="icon green-check">✔</span> Centralized contact book</li>
          <li><span class="icon green-check">✔</span> Role-based management</li>
          <li><span class="icon green-check">✔</span> Lead ownership & transfer</li>
          <li><span class="icon green-check">✔</span> Performance tracking</li>
        </ul>
        <button class="btn gradient-btn-light">Try Now</button>
      </div>

      <div class="card enterprise-card">
        <span class="badge">ENTERPRISE</span>
        <div class="price-block">
          <h3 class="price" id="enterprise-current-price"></h3>
          <p class="subtext">Everything in Team, plus enterprise-grade power.</p>
        </div>
        
        <ul class="features">
          <li><span class="icon purple-check">✔</span> CRM integration</li>
          <li><span class="icon purple-check">✔</span> API access</li>
          <li><span class="icon purple-check">✔</span> Custom workflows</li>
          <li><span class="icon purple-check">✔</span> Advanced permissions</li>
        </ul>
        <button class="btn gradient-btn">Contact Sales</button>
      </div>

    </div>
  </div> -->
<div class="pricing-container" *ngIf="isPlansReady">
  <div *ngFor="let plan of vcardPlansForView" class="card" [class.active]="activePlanId === plan.id" (click)="setActive(plan.id)">

    <div class="plan-badge">{{ plan.title }}</div>

    <div class="price-section">
      <h2 class="current-price" *ngIf="plan.title !== 'ENTERPRISE' && plan.title !== 'TEAM'">
        {{ formatPlanPrice(plan, 'current') }}
        <span class="period" *ngIf="!isFreeAmount(getPriceModel(plan)?.current)">{{ plan.period }}</span>
      </h2>
      <h2 class="current-price" *ngIf="plan.title === 'TEAM'">
        {{ formatTeamPrice(planAmount) }}
        <span class="period" *ngIf="!isFreeAmount(planAmount)">/ month</span>
      </h2>
      <h2 class="current-price" *ngIf="plan.title === 'ENTERPRISE'">
        For Free Trial
      </h2>

      <span
        *ngIf="plan.title !== 'ENTERPRISE' && (detectedCountry === 'IN' ? plan.price?.india?.original : plan.price?.default?.original)"
        class="strikethrough">
        {{ formatPlanPrice(plan, 'original') }}
      </span>

      <p class="plan-subtext" *ngIf="plan.subtext">
        {{ plan.subtext }}
      </p>
    </div>

    <span *ngIf="plan.title !== 'ENTERPRISE' && plan.title !== 'TEAM' && !isFreeAmount(getPriceModel(plan)?.yearlyPrice)">
      {{ formatPlanPrice(plan, 'yearlyPrice') }}
      · billed annually · {{ plan.savings }}
    </span>
    <span *ngIf="plan.title === 'TEAM' && !isFreeAmount(planAmountYearly)">
      {{ formatTeamPrice(planAmountYearly) }}
      · billed annually
    </span>
    <p class="plan-subtext" *ngIf="plan.title === 'TEAM'">Select QR pack</p>
    <div class="user-selector" *ngIf="plan.title === 'TEAM'">
      <span *ngFor="let num of userOptions" (click)="selectUser(num)" [class.active]="user === num" class="user-pill">
        {{ num }}
      </span>
    </div>
    <p class="plan-subtext" *ngIf="plan.title !== 'ENTERPRISE' && plan.vcardCount">QR VCards: {{ plan.vcardCount }}</p>
    <ul class="feature-list">
      <li *ngFor="let feature of plan.features">
        <span class="check-icon" [style.background-color]="activePlanId === plan.id ? '#4ade80' : '#5d55b4'">
          ✔
        </span>
        <span class="feature-text">{{ feature }}</span>
      </li>
    </ul>

    <button [ngClass]="activePlanId === plan.id ? 'btn-active' : 'btn-normal'" (click)="onClickPlanAction(plan)">
      {{ plan.btnText }}
    </button>
  </div>
</div>



<div class="expansion-hub" *ngIf="isPlansReady">


  <div class="tier-grid">
    <div *ngFor="let plan of smartSitePlans" class="growth-tier" [class.is-active]="activePlanId === plan.id"
      (click)="setActive(plan.id)">

      <!-- <div class="price-stack">
        <div class="rate-primary"> {{
          (detectedCountry === 'IN'
          ? plan.price.india.current
          : plan.price.default.current)
          | currency:(detectedCountry === 'IN' ? 'INR' : 'USD'):'symbol':'1.0-0'
          }} <small>/ month</small></div>
        <div class="rate-secondary">
          <span *ngIf="plan.price.india.original||plan.price.default.original" class="strikethrough"> {{
            (detectedCountry === 'IN'
            ? plan.price.india.original
            : plan.price.default.original)
            | currency:(detectedCountry === 'IN' ? 'INR' : 'USD'):'symbol':'1.0-0'
            }}</span>
          <span> {{
            (detectedCountry === 'IN'
            ? plan.price.india.yearlyPrice
            : plan.price.default.yearlyPrice)
            | currency:(detectedCountry === 'IN' ? 'INR' : 'USD'):'symbol':'1.0-0'
            }} · {{ plan.savings }}</span>
        </div>
      </div> -->
      <div class="price-stack">
        <div class="rate-primary">
          {{ formatPlanPrice(plan, 'current') }}
          <small *ngIf="!isFreeAmount(getPriceModel(plan)?.current)">/ month</small>
        </div>

        <div class="rate-secondary">

          <!-- Original price -->
          <span *ngIf="(detectedCountry === 'IN'
        ? plan.price.india.original
        : plan.price.default.original)" class="strikethrough">
            {{ formatPlanPrice(plan, 'original') }}
          </span>

          <!-- Yearly price -->
          <span *ngIf="!isFreeAmount(getPriceModel(plan)?.yearlyPrice)">
            {{ formatPlanPrice(plan, 'yearlyPrice') }}
            · billed annually · {{ plan.description }}
          </span>

        </div>
      </div>

      <h3 class="tier-name">{{ plan.name }}</h3>

      <ul class="benefit-list">
        <li *ngFor="let feature of plan.features" class="benefit-item">
          <span class="benefit-check"></span> {{ feature }}
        </li>
      </ul>

      <button [ngClass]="activePlanId === plan.id ? 'btn-active' : 'btn-normal'" (click)="onClickPlanAction(plan)">Get Started</button>
    </div>
  </div>
</div>

<ng-template #planPriceModal>
  <div class="modal-head">
    <div>
      <h1 mat-dialog-title>Select Billing</h1>
      <p class="modal-subtitle">{{ selectedPlanForSubscription?.title || selectedPlanForSubscription?.name }}</p>
    </div>
    <button mat-icon-button (click)="closePriceModal()" class="modal-close-btn">
        <mat-icon>close</mat-icon>
    </button>
  </div>
  <div mat-dialog-content>
    <div class="billing-options">
      <label class="billing-option" [class.active]="selectedBilling === 'monthly'">
        <input type="radio" name="billingType" value="monthly" [(ngModel)]="selectedBilling" />
        <div class="billing-content">
          <div class="billing-title">{{ isSelectedPlanFreeTrial ? 'Free Trial' : 'Monthly' }}</div>
          <div class="billing-price">
            {{ formatSelectedPlanPrice(selectedMonthlyAmount) }}
            <span *ngIf="!isFreeAmount(selectedMonthlyAmount)">/ month</span>
          </div>
        </div>
      </label>

      <label class="billing-option" [class.active]="selectedBilling === 'annual'">
        <input type="radio" name="billingType" value="annual" [(ngModel)]="selectedBilling" />
        <div class="billing-content">
          <div class="billing-title">Yearly <span class="billing-save" *ngIf="yearlySavingsPercent > 0"> Save {{ yearlySavingsPercent }}%</span></div>
          <div class="billing-price">
            {{ formatSelectedPlanPrice(selectedAnnualAmount) }}
            <span *ngIf="!isFreeAmount(selectedAnnualAmount)">/ year</span>
          </div>
        </div>
      </label>
    </div>

    <div class="modal-features" *ngIf="selectedPlanFeatures.length">
      <ul>
        <li *ngFor="let feature of selectedPlanFeatures">
          <span class="feature-tick">✓</span> {{ feature }}
        </li>
      </ul>
    </div>
  </div>
  <div mat-dialog-actions align="center">
    <button mat-flat-button color="primary" [disabled]="isProcessingSubscription" (click)="onConfirmSubscription()">{{ isProcessingSubscription ? 'Processing...' : 'Continue' }}</button>
  </div>
</ng-template>

<ng-template #stripePaymentModal>
  <div class="modal-head">
    <div>
      <h1 mat-dialog-title>Complete Payment</h1>
      <p class="modal-subtitle">{{ selectedPlanForSubscription?.title || selectedPlanForSubscription?.name }}</p>
    </div>
    <button mat-icon-button (click)="closeStripePaymentModal()" class="modal-close-btn" [disabled]="isProcessingSubscription">
        <mat-icon>close</mat-icon>
    </button>
  </div>
  <div mat-dialog-content>
    <div class="stripe-payment-wrap">
      <div id="stripe-payment-element"></div>
      <p class="stripe-error" *ngIf="stripeErrorMessage">{{ stripeErrorMessage }}</p>
    </div>
  </div>
  <div mat-dialog-actions align="center">
    <button mat-flat-button color="primary" [disabled]="isProcessingSubscription" (click)="onConfirmStripePayment()">
      {{ isProcessingSubscription ? 'Processing...' : 'Pay Now' }}
    </button>
  </div>
</ng-template>

<ng-template #contactModal>
  <div class="modal-head">
    <div>
      <h1 mat-dialog-title>Contact Sales</h1>
    </div>
    <button mat-icon-button (click)="closePriceModal()" class="modal-close-btn">
        <mat-icon>close</mat-icon>
    </button>
  </div>
  <div mat-dialog-content>
    <p>Contact us at admin@scanfluence.com</p>
  </div>
  <div mat-dialog-actions align="center">
    <button mat-flat-button color="primary" (click)="closePriceModal()">Okay</button>
  </div>
</ng-template>
